import React from 'react'
import PropTypes from 'prop-types'
import { useMarkCompleteV3 } from 'hooks/useMarkCompleteV3'
import confettiSelector from 'components/ConfettiButton/confettiSelector'
import Component from './component'

/**
 * Connects the useMarkCompleteV3 hook to the presentational component.
 *
 * Props:
 *  coursePointer     - coursePointer from routeContent (GET /v1/content response)
 *  courseNodeId      - from page.page.metadata.resource_metadata
 *                      .course_node_connector.course_node_entry_point
 *  contentGroupCode  - curriculum-service content group code (e.g. 'dwb')
 *  instructorDataKey - top-level key in /v2/instructor/me response (e.g. 'Dwb')
 *  siteId            - optional; resolved from userContext/URL if omitted
 */
function MarkCompleteV3Container({
  coursePointer,
  courseNodeId,
  contentGroupCode,
  instructorDataKey,
  siteId,
  useSecondaryMarkCompleteButton = false,
}) {
  const { isComplete, handleMarkComplete } = useMarkCompleteV3({
    coursePointer,
    courseNodeId,
    contentGroupCode,
    instructorDataKey,
    siteId,
  })

  const fireConfetti = confettiSelector('large')

  const onMarkComplete = async event => {
    const button = event.currentTarget
    const success = await handleMarkComplete()
    if (success) {
      await fireConfetti({ currentTarget: button })
    }
  }

  return (
    <Component
      handleMarkComplete={onMarkComplete}
      isComplete={isComplete}
      useSecondaryMarkCompleteButton={useSecondaryMarkCompleteButton}
    />
  )
}

MarkCompleteV3Container.propTypes = {
  contentGroupCode: PropTypes.string.isRequired,
  courseNodeId: PropTypes.string,
  coursePointer: PropTypes.shape({
    href: PropTypes.string,
    method: PropTypes.string,
    query: PropTypes.object,
  }),
  instructorDataKey: PropTypes.string.isRequired,
  siteId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  useSecondaryMarkCompleteButton: PropTypes.bool,
}

export default MarkCompleteV3Container
